var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8818 4H5.25418C4.93042 4 4.66797 4.26245 4.66797 4.58621C4.66797 6.45188 5.4091 8.24113 6.72833 9.56036L7.58176 10.4138C7.66651 10.4985 7.70888 10.5409 7.73922 10.5816C7.92429 10.8298 7.92429 11.1702 7.73922 11.4184C7.70888 11.4591 7.66651 11.5015 7.58176 11.5862L6.72833 12.4396C5.4091 13.7589 4.66797 15.5481 4.66797 17.4138C4.66797 17.7375 4.93042 18 5.25418 18H13.8818C14.2055 18 14.468 17.7375 14.468 17.4138C14.468 15.5481 13.7268 13.7589 12.4076 12.4396L11.5542 11.5862C11.4694 11.5015 11.4271 11.4591 11.3967 11.4184C11.2117 11.1702 11.2117 10.8298 11.3967 10.5816C11.4271 10.5409 11.4694 10.4985 11.5542 10.4138L12.4076 9.56036C13.7268 8.24113 14.468 6.45188 14.468 4.58621C14.468 4.26245 14.2055 4 13.8818 4Z",
    stroke: "#101928",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiment);
export default __webpack_public_path__ + "static/media/experiment.0bfc6dde143c1cc8c9bd3f26c3203545.svg";
export { ForwardRef as ReactComponent };